class StaticPageService {
  constructor () {
    // useRequestFetch resolves relative /api/ URLs during SSR; on the app
    // target prependHostIfNeeded points them at the deployed server.
    this.fetch = useRequestFetch()
  }

  getStaticPage = async ({ slug, preview = false }) => {
    try {
      return await this.fetch(prependHostIfNeeded('/api/contentful/static-page/get-static-page'), {
        method: 'POST',
        body: {
          slug,
          preview
        }
      })
    } catch {
      return null
    }
  }
}

export default StaticPageService
